export default "__VITE_ASSET__XR0zt$np__"